import styled from 'styled-components'

import { Column, Skeleton, Spacer, fromLg } from '@syconium/little-miss-figgy'

export const Container = styled(Column)`
  width: 100%;
`

export const CategoryTitleSkeleton = styled(Skeleton)`
  ${fromLg} {
    height: 40px;
  }
`

export const ResponsiveSpacer = styled(Spacer)`
  ${fromLg} {
    height: 24px;
  }
`

export const ResponsiveSkeleton = styled(Skeleton)`
  width: 100%;
  ${fromLg} {
    height: 285px;
  }
`
